import React from 'react'
import {FaGithub} from 'react-icons/fa'
import {Link} from 'react-router-dom'
import PropTypes from  'prop-types'
import Home from '../pages/Home'

function Navbar() {
  return (
    <nav className='navbar shadow-lg bg-neutral
    text-neutral-content'>
        <div className="container mx-auto">
        <div className="flex-none px-2 mx-2">
        <Link to='/' className='text-lg font-bold align-middle'>
            
                RB
            </Link>
        </div>
        <div className="flex-1 px-2 mx-2">
            <div className="flex justify-end">
                <Link to='/projects' className='btn btn-ghost btn-sm rounded-btn'>
                    Projects
                </Link>
                <Link to='/work-experience' className='btn btn-ghost btn-sm rounded-btn'>
                    Experience
                </Link>
                <Link to='/contact' className='btn btn-ghost btn-sm rounded-btn'>
                    Contact
                </Link>
            </div>
        </div>
        </div>
        
    </nav>
  )
}

export default Navbar